import script from "./CellFile.vue?vue&type=script&setup=true&lang=js"
export * from "./CellFile.vue?vue&type=script&setup=true&lang=js"

import "./CellFile.vue?vue&type=style&index=0&id=4faf8e4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4faf8e4b"]])

export default __exports__